import {
    SET_EDITING_EUTR_ELEMENTS,
    SET_EDITING_EUTR_ELEMENT,
    SET_EDITING_EUTR_PRE_SUPPLIER,
    EutrTypes,
    EutrState
} from "./types";


export function eutrReducer(
    state: EutrState = {editingEutrElements: []},
    action: EutrTypes
): EutrState {
    switch (action.type) {
        case SET_EDITING_EUTR_ELEMENTS:
            return {
                editingEutrElements: action.payload,
                editingEutrElement: undefined,
                editingEutrPreSupplier: undefined
            };
        case SET_EDITING_EUTR_ELEMENT:
            return {
                editingEutrElements: state.editingEutrElements,
                editingEutrElement: action.payload,
                editingEutrPreSupplier: undefined
            };
        case SET_EDITING_EUTR_PRE_SUPPLIER:
            return {
                editingEutrElements: state.editingEutrElements,
                editingEutrElement: state.editingEutrElement,
                editingEutrPreSupplier: action.payload
            };
        default:
            return state;
    }
}
